import BaseAPIService from './BaseAPIService';

export default class MomentService extends BaseAPIService {
	constructor() {
		super();
	}

	async getMoments(limit = 30, next = undefined) {
		const query = require('@/graphql/queries/moments.gql');
		const variables = {
			limit,
			next,
			identifiers: ["mekongmemories"]
		};
		const result = await this.query({ query, variables });
		return result.data.moments;
	}
}
